module.exports = __webpack_public_path__ + "static/quiz_mhnn_manger-dd54936a0476b3eadb41475c58f206f5.png";